import './MobileMenu.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ROUTE_ECATALOGS,
  ROUTE_NODES_CLEARANCE,
  ROUTE_NODES_DISCOUNT,
  ROUTE_NODES_EXCLUSIVITY,
  ROUTE_ORDERS,
  ROUTE_QUOTES,
  ROUTE_WISHLISTS,
} from '@/common/constants';
import { useConfig } from '@/common/contexts/ConfigContext';
import { ReactComponent as OrderSvg } from '@/ebat/assets/icons/order.svg';
import { ReactComponent as QuoteSvg } from '@/ebat/assets/icons/quote.svg';
import HeaderNavLink from '@/ebat/components/blocks/Header/HeaderNavLink/HeaderNavLink';
// eslint-disable-next-line import/no-cycle
import ProductsMenuButton from '@/ebat/components/blocks/Header/ProductsMenu/ProductsMenuButton/ProductsMenuButton';
import { useHeaderAccessesContext } from '@/ebat/contexts/Header/HeaderAccessesContext/HeaderAccessesContext';
import { useHeaderMenuContext } from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

import {
  MobileMenuDefaultProps,
  MobileMenuPropTypes,
} from './MobileMenu.proptypes';

const MobileMenu = ({ className }) => {
  const { t } = useTranslation();
  const { isEbat } = useConfig();
  const { handleClose } = useHeaderMenuContext();
  const {
    quotes: hasQuotesAccesses,
    wishlists: hasWishlistsAccesses,
    orders: hasOrdersAccesses,
    showClearance,
    showECatalog,
    showPromo,
  } = useHeaderAccessesContext();

  return (
    <div
      role="presentation"
      className={cn(className, 'mobile-menu')}
      onClick={handleClose}
    >
      <ProductsMenuButton className="mobile-menu__primary-item mobile-menu__products" />
      {isEbat && (
        <HeaderNavLink
          className="mobile-menu__primary-item"
          context={cn(
            { 'mobile-menu-btn-quotes-active': hasQuotesAccesses },
            { 'mobile-menu-btn-quotes-disabled': !hasQuotesAccesses },
          )}
          Icon={<QuoteSvg />}
          label={t('ebat:entities:layout.header.my_account.quotes_span')}
          to={ROUTE_QUOTES}
          disabled={!hasQuotesAccesses}
        />
      )}
      <HeaderNavLink
        className="mobile-menu__primary-item"
        context={cn(
          { 'mobile-menu-btn-orders-active': hasOrdersAccesses },
          { 'mobile-menu-btn-orders-disabled': !hasOrdersAccesses },
        )}
        Icon={<OrderSvg />}
        label={t('ebat:entities:layout.header.my_account.orders_span')}
        to={ROUTE_ORDERS}
        disabled={!hasOrdersAccesses}
      />
      <div className="mobile-menu__divider" />
      <HeaderNavLink
        className="mobile-menu__secondary-item"
        context={cn(
          { 'mobile-menu-btn-wishlists-active': hasWishlistsAccesses },
          { 'mobile-menu-btn-wishlists-disabled': !hasWishlistsAccesses },
        )}
        variant="secondary"
        label={t('ebat:entities:layout.header.my_account.favorite')}
        to={ROUTE_WISHLISTS}
        disabled={!hasWishlistsAccesses}
      />
      {showPromo && (
        <HeaderNavLink
          className="mobile-menu__secondary-item"
          context="mobile-menu-btn-discount"
          variant="secondary"
          label={t('common:entities:layout.header.discount.label')}
          to={ROUTE_NODES_DISCOUNT}
        />
      )}
      {showClearance && (
        <HeaderNavLink
          className="mobile-menu__secondary-item"
          context="mobile-menu-btn-clearance"
          variant="secondary"
          label={t('ebat:entities:layout.header.destock')}
          to={ROUTE_NODES_CLEARANCE}
        />
      )}
      <HeaderNavLink
        className="mobile-menu__secondary-item"
        context="mobile-menu-btn-exclusivity"
        variant="secondary"
        label={t('ebat:entities:layout.header.exclusivity')}
        to={ROUTE_NODES_EXCLUSIVITY}
      />
      {showECatalog && (
        <HeaderNavLink
          className="mobile-menu__secondary-item"
          context="mobile-menu-btn-ecatalog"
          variant="secondary"
          label={t('ebat:entities:cms.ecatalogs.title')}
          to={ROUTE_ECATALOGS}
        />
      )}
    </div>
  );
};

MobileMenu.defaultProps = {
  ...MobileMenuDefaultProps,
};

MobileMenu.propTypes = {
  ...MobileMenuPropTypes,
};

export default MobileMenu;
